import { useCMSApiQuery } from './useCMSApiQuery';

export function useServicesMenuQuery(locale: string, enabled: boolean) {
  return useCMSApiQuery<ServicesMenu>(
    `/cms/v1/menu-items?PageType=Services&locale=${locale}`,
    undefined,
    { enabled }
  );
}
export type ServicesMenu = {
  menuitems: Service[];
  total: number;
};
export type Service = {
  nodeAliasPath: string;
  nodeGUID: string;
  pageName: string;
  pageSubType: null;
  pageType: string;
  pageUrl: string;
  partialPageUrl: string;
  subMenu: Service[];
  vendorName: string;
};
